import React from 'react';
import { Grid, Paper, Typography, CircularProgress, Box, Button } from '@material-ui/core';
import { MdRefresh } from 'react-icons/md';
import { FaDownload } from 'react-icons/fa';
import SimpleCard from '../../../utils/card';
import { useDashboardStyles } from './styles/DashboardInformeStyle';
import { DonutChart, BarChart } from './components/charts';
import { useDashboardData } from './hooks/useDashboardData';
import { useExportInformeMes } from './hooks/useExportInformeMes';
import { USER_NAME } from '../../../app/api-client/constants';
import { TablaEstaciones } from './components/table';

export const DashboardInforme = () => {
  const classes = useDashboardStyles();
  const { loading, stats, estaciones, donutData, barData, refetch } = useDashboardData();
  const { exportar, loading: loadingExport } = useExportInformeMes();

  const userName = localStorage.getItem(USER_NAME) || 'Usuario';

  const fechaFormateada = new Date().toLocaleDateString('es-CO', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const mesActualNombre = new Date().toLocaleDateString('es-CO', { month: 'long' });
  const mesAnteriorNombre = new Date(new Date().setMonth(new Date().getMonth() - 1))
    .toLocaleDateString('es-CO', { month: 'long' });

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <Paper className={classes.paper} style={{ minHeight: '100%' }}>


      <Grid container spacing={1} style={{ marginBottom: 8 }}>
        <Grid item xs={12}>
          <Typography className={classes.greeting}>
            Hola,{' '}
            <span className={classes.greetingName}>{userName}</span>
          </Typography>
          <Typography className={classes.dateText}>
            Resumen operativo de hoy, {fechaFormateada}.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box className={classes.headerActions}>
            <Button
              variant="outlined"
              startIcon={<MdRefresh />}
              className={classes.refreshBtn}
              onClick={refetch}
              disabled={loading}
            >
              Refrescar
            </Button>
            <Button
              variant="contained"
              startIcon={loadingExport ? <CircularProgress size={16} style={{ color: 'white' }} /> : <FaDownload />}
              className={classes.downloadBtn}
              onClick={exportar}
              disabled={loadingExport}
            >
              {loadingExport ? 'Descargando...' : 'Descargar informe'}
            </Button>
          </Box>
        </Grid>
      </Grid>

      {loading ? (
        <Box style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>

          <Grid container spacing={2} style={{ marginBottom: 24 }}>
            <Grid item xs={12} sm={6} md={3}>
              <SimpleCard
                title={stats.estacionesActivas ?? '-'}
                messageInfo="Estaciones activas"
                img="bascula"
                event={() => { }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <SimpleCard
                title={stats.estacionesOffline ?? '-'}
                messageInfo="Estaciones offline"
                subtitle={
                  stats.registrosPendientes != null
                    ? `${stats.registrosPendientes} registros pendientes`
                    : 'Estaciones offline'
                }
                img="validacion"
                event={() => { }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <SimpleCard
                title={stats.medicionesMes ?? '-'}
                messageInfo={`Mediciones ${capitalize(mesActualNombre)}`}
                img="datos"
                event={() => { }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <SimpleCard
                title={stats.estacionesInactivas ?? '-'}
                messageInfo="Estaciones inactivas"
                img="administracion"
                event={() => { }}
              />
            </Grid>
          </Grid>


          <Grid container spacing={3}>
            <Grid item xs={12} md={5}>
              <DonutChart
                series={donutData.series}
                labels={donutData.labels}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <BarChart
                categorias={barData.categorias}
                serieActual={barData.serieActual}
                serieAnterior={barData.serieAnterior}
                mesActual={`Mediciones ${capitalize(mesActualNombre)}`}
                mesAnterior={`Mediciones ${capitalize(mesAnteriorNombre)}`}
              />
            </Grid>
          </Grid>

          <br />
          <TablaEstaciones data={estaciones} />


        </>
      )}

    </Paper>
  );
};
